import { ReactSession } from "../../../lib/secure_reactsession";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "../../themes/userq/Button/Button";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Text } from "../../themes/userq/Text/Text";
import { CheckBox } from "../../themes/userq/CheckBox/CheckBox";
import { showToast } from "../../../lib/helpers";

export default function ScreenRecordingPermissionModal({
    openModal,
    closeModal,
    testLanguage,
    requestAccepted,
}) {
    const navigate = useNavigate();
    const wrapperRef = useRef(null);
    const [isPermissionGranted, setIsPermissionGranted] = useState(false);
    const [endTestTerm, setEndTestTerm] = useState(false);
    const [sensitiveInfoTerm, setSensitiveInfoTerm] = useState(false);

    /*   function useOutsideAlerter(ref) {
        useEffect(() => {
          function handleClickOutside(event) {
           if (ref.current && !ref.current.contains(event.target)) {
              if (event.target.nodeName == "DIV") {
                !ReactSession.get("token")
                  ? navigate("/tester/sign-in")
                  : navigate("/");
              }
            }
            
             
          }
          // Bind the event listener
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref]);
      } */

    function handleManualClose() {
        !ReactSession.get("token")
            ? navigate("/tester/sign-in")
            : navigate("/");
    }

    /* useOutsideAlerter(wrapperRef); */

    return (
        <Modal
            show={openModal}
            centered
            className="fade custom-modal-wrap  nda-agreement-modal "
        >
            <Modal.Body
                className={
                    testLanguage == "ar" ? "arabic_wrapper p-28" : "p-28"
                }
            >
                <div className="modal-inner-text">
                    <div className="modal-header-top">
                        <Text type={"h3"} cssClasses={"d-flex"}>
                            <Icon
                                size={"large"}
                                value={"screen-recording"}
                                cssClasses={"mr-8 "}
                                colorClass={"gray-900-svg"}
                            />
                            Screen recording permission
                        </Text>
                        <button
                            type="button"
                            className="close"
                            onClick={() => {
                                handleManualClose();
                            }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <Icon
                                    colorClass={"gray-900-svg"}
                                    value={"close"}
                                    size={"large"}
                                    hover={true}
                                />
                            </span>
                        </button>
                    </div>
                    <div className="congrats-modal-header-step-second mb-1">
                        <img
                            src={
                                process.env.REACT_APP_URL +
                                "img/screen-recording.png"
                            }
                        />
                    </div>

                    <div className="nda-modal-text mt-20">
                        <>
                            <Text
                                type={"body-text-3"}
                                fontWeight={"medium-font"}
                            >
                                Your screen will be recorded while taking the
                                test and light blue border will appear around
                                your screen to indicate that recording is in
                                progress.
                            </Text>

                            <Text
                                type={"body-text-3"}
                                fontWeight={"semi-bold-font"}
                                cssClasses={"mt-20"}
                            >
                                Before you begin, please confirm the following:
                            </Text>

                            <div className={""}>
                                <ul className="list-unstyled">
                                    <li className="mt-20 d-flex">
                                        <CheckBox
                                            checked={false}
                                            onChange={() => {
                                                setIsPermissionGranted(
                                                    !isPermissionGranted
                                                );
                                            }}
                                            id="permission-check"
                                        />
                                        <label htmlFor="permission-check">
                                            <Text
                                                type={"body-text-3"}
                                                fontWeight={"medium-font"}
                                            >
                                                I understand and give permission
                                                for my screen to be recorded
                                                while taking the test
                                            </Text>
                                        </label>
                                    </li>
                                    <li className="mt-20 d-flex">
                                        <CheckBox
                                            checked={false}
                                            onChange={() => {
                                                setEndTestTerm(!endTestTerm);
                                            }}
                                            id="end-test-check"
                                        />
                                        <label htmlFor="end-test-check">
                                            <Text
                                                type={"body-text-3"}
                                                fontWeight={"medium-font"}
                                            >
                                                I understand that stopping
                                                screen sharing, switching or
                                                closing the page before
                                                completion will immediately end
                                                the test, and I will not receive
                                                payment or incentives
                                            </Text>
                                        </label>
                                    </li>
                                    <li className="mt-20 d-flex">
                                        <CheckBox
                                            checked={false}
                                            onChange={() => {
                                                setSensitiveInfoTerm(
                                                    !sensitiveInfoTerm
                                                );
                                            }}
                                            id="sensitive-info-check"
                                        />
                                        <label htmlFor="sensitive-info-check">
                                            <Text
                                                type={"body-text-3"}
                                                fontWeight={"medium-font"}
                                            >
                                                I will not share any sensitive
                                                information, personal details,
                                                or financial data while my
                                                screen is being recorded
                                            </Text>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                            <div className="confirm-buttons-wrap mt-20">
                                <Button
                                    type="primary"
                                    size="large"
                                    label={"Next"}
                                    onClick={() => {
                                        if (
                                            isPermissionGranted &&
                                            endTestTerm &&
                                            sensitiveInfoTerm
                                        ) {
                                            requestAccepted();
                                        } else {
                                            showToast(
                                                "You must check all the boxes to proceed. Please review and confirm your acknowledgment before starting the test.",
                                                "error"
                                            );
                                        }
                                    }}
                                    state={
                                        !(
                                            isPermissionGranted &&
                                            endTestTerm &&
                                            sensitiveInfoTerm
                                        )
                                            ? "disabled"
                                            : "active"
                                    }
                                    microLoading={false}
                                />
                            </div>
                        </>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
